import React from 'react';

import Icon from "../../../../../components/Icon";
import pictureTemperature from "./images/temperature.png";
import pictureCrossSmall from "./images/cross-small.png";
import pictureCheck from "./images/check.png";
import {Link} from "react-router-dom";

const Condition = ({slug}) => {
    if(slug === "soft"){
        return (
            <ul className="taggage-media-main-content-temp-list">
                <li><img src={pictureCrossSmall} alt={""} />Aucune partie génitale visible</li>
                <li><img src={pictureCheck} alt={""} />Photo de nu avec parties génitales cachées</li>
                <li><img src={pictureCheck} alt={""} />La poitrine et les tétons sont autorisés</li>
            </ul>
        )
    }

    if(slug === "hot"){
        return (
            <ul className="taggage-media-main-content-temp-list">
                <li>
                    <img src={pictureCheck} alt={""} />
                    <p>Parties génitales <span className="list-subtitle">(minou / pénis)</span> en position naturelle</p>
                </li>
                <li><img src={pictureCrossSmall} alt={""} />Pas d'érection</li>
                <li><img src={pictureCrossSmall} alt={""} />Pas de jambes écartées</li>
                <li><img src={pictureCrossSmall} alt={""} />Pas de simulation d'acte sexuel</li>
            </ul>
        )
    }

    if(slug === "hard"){
        return (
            <ul className="taggage-media-main-content-temp-list">
                <li>
                    <img src={pictureCheck} alt={""} />
                    <p>Parties génitales <span className="list-subtitle">(minou / pénis)</span> en position sexuelle</p>
                </li>
                <li><img src={pictureCheck} alt={""} />Relation sexuelle</li>
                <li><img src={pictureCheck} alt={""} />Masturbation</li>
                <li><img src={pictureCheck} alt={""} />Avec du recul et esthétisme</li>
            </ul>
        )
    }

    if(slug === "gros-plan"){
        return (
            <ul className="taggage-media-main-content-temp-list">
                <li>
                    <img src={pictureCheck} alt={""} />
                    <p>Parties génitales <span className="list-subtitle">(minou / pénis)</span> en gros plans</p>
                </li>
                <li><img src={pictureCheck} alt={""} />Actes sexuels zoomés ou très crus</li>
                <li><img src={pictureCheck} alt={""} />Dédicaces de pénis</li>
                <li><img src={pictureCheck} alt={""} />Insertions, sperme, pratiques extrêmes...
                </li>
            </ul>
        )
    }

}


const CategoriesTemperature = (props) => {

    return (
        <section id="pict-gender">
            <div className="taggage-media-main-content-title">
                <img src={pictureTemperature} alt="" />
                <h1>Vérifier la température des photos</h1>
            </div>


            <div className="taggage-media-main-content-temp">
                {props.childrens.filter(subCategory => subCategory.totalModeration > 0).map(subCategory =>(
                    <div className="under-temp" key={subCategory._id}>
                        <div className={`taggage-media-main-content-temp-card ${subCategory.slug}`}>
                            <p className="taggage-media-main-content-temp-card-gender">{subCategory.title}</p>
                            <Link to={`${props.currentUrl}-photo/${subCategory._id.toString()}`} className="count-media-cta">
                                <div className="count-media">
                                    <Icon type={"picture-2"} size={"w-20"} className={"mr-4"} />
                                    <p>{subCategory.totalModeration || 0}<br /><span>médias</span></p>
                                </div>
                                <Icon type={"arrow-right-2"} size={"w-20"} className={"mr-4"} />
                            </Link>
                        </div>
                        <Condition slug={subCategory.slug} />
                    </div>
                ))}
            </div>
        </section>
    )
};

export default CategoriesTemperature;